import React, { Component } from "react";
import { Row, Col, Form, FormControl, Modal, Image } from "react-bootstrap";
import VerificationIcon from "../../../assets/images/VerifyIcon.svg";
import Table from "react-bootstrap/Table";
import { connect } from "react-redux";
import { MenuItem, Select } from "@material-ui/core";
import { actionFetchCountries } from "../../../common/redux/actions/actionCountry";
import "./PriceRecommendation.scss";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import Loader from "../../common/Loader";
import AddCountryModal from "./AddCountryModal";
import delivaApiService from "../../../common/services/apiService";
import {
  getLocalStorage,
  showErrorToast,
  showSuccessToast,
  getDistanceUnit,
} from "../../../common/helpers/Utils";
import recommendedPricingGuidePDF from "../../../assets/pdf/Recommended Pricing Guide.pdf";

const normalizeDistanceUnit = (unit) => {
  if (!unit) return "Km";
  const u = String(unit).trim().toLowerCase();
  if (u === "mi" || u === "miles" || u === "mile") return "Miles";
  if (u === "km" || u === "kilometer" || u === "kilometers") return "Km";
  return unit;
};

const DEFAULT_COUNTRIES = [
  { code: "NG", name: "Nigeria", currency: "NGN" },
  { code: "US", name: "United States", currency: "USD" },
];

const DEFAULT_BASE_RATES_ROWS = [
  { parameter: "Base Fare", values: {} },
  { parameter: "Base Distance", values: {} },
  { parameter: "Rate/Minute", values: {} },
  { parameter: "Minimum Fare", values: {} },
  { parameter: "Range Low Multiplier", values: {} },
  { parameter: "Range High Multiplier", values: {} },
  { parameter: "Rounding Unit", values: {} },
  { parameter: "Country Price Multiplier", values: {} },
];

const DEFAULT_WEIGHT_TIERS_ROWS = [
  { from: "0", to: "5", unit: "kg", baseRate: "0" },
  { from: "5", to: "10", unit: "kg", baseRate: "20" },
  { from: "10", to: "30", unit: "kg", baseRate: "50" },
  { from: "30", to: "50", unit: "kg", baseRate: "100" },
  { from: "50", to: "50+", unit: "kg", baseRate: "200" },
];

const DEFAULT_ITEM_CLASSES_ROWS = [
  { className: "STANDARD", multiplier: "1" },
  { className: "DOCUMENTS", multiplier: "1" },
  { className: "FRAGILE", multiplier: "1.2" },
  { className: "PERISHABLE", multiplier: "1.25" },
  { className: "ELECTRONICS", multiplier: "1.1" },
  { className: "HIGH VALUE", multiplier: "1.3" },
  { className: "OVERSIZED", multiplier: "1.5" },
];

const DEFAULT_URGENCY_ROWS = [
  { urgency: "ECONOMY", multiplier: "0.8" },
  { urgency: "STANDARD", multiplier: "1" },
  { urgency: "EXPRESS", multiplier: "1.2" },
  { urgency: "RUSH", multiplier: "1.5" },
  { urgency: "SCHEDULED", multiplier: "1.0" },
];

const DEFAULT_VEHICLE_TYPES_ROWS = [
  { vehicleType: "BICYCLE", multiplier: "1", maxWeight: "5" },
  { vehicleType: "MOTORCYCLE", multiplier: "1", maxWeight: "15" },
  { vehicleType: "TRICYCLE", multiplier: "1.2", maxWeight: "50" },
  { vehicleType: "CAR", multiplier: "1.1", maxWeight: "50" },
  { vehicleType: "SUV", multiplier: "1.3", maxWeight: "100" },
  { vehicleType: "VAN", multiplier: "2", maxWeight: "200" },
  { vehicleType: "SMALL TRUCK", multiplier: "2.5", maxWeight: "500" },
  { vehicleType: "MEDIUM TRUCK", multiplier: "3", maxWeight: "2000" },
  { vehicleType: "LARGE TRUCK", multiplier: "4", maxWeight: "5000" },
  {
    vehicleType: "TRAILER",
    multiplier: "1",
    maxWeight: "10000",
  },
  {
    vehicleType: "SHORT AND FULL TRAILER",
    multiplier: "5",
    maxWeight: "10000",
  },
];

const DEFAULT_TIME_OF_DAY_ROWS = [
  { hours: "0 - 5", hourStart: 0, hourEnd: 5, multiplier: "1.3" },
  { hours: "6 - 7", hourStart: 6, hourEnd: 7, multiplier: "1.1" },
  { hours: "8 - 9", hourStart: 8, hourEnd: 9, multiplier: "1.15" },
  { hours: "10 - 11", hourStart: 10, hourEnd: 11, multiplier: "1.0" },
  { hours: "12 - 13", hourStart: 12, hourEnd: 13, multiplier: "1.05" },
  { hours: "14 - 16", hourStart: 14, hourEnd: 16, multiplier: "1.0" },
  { hours: "17 - 19", hourStart: 17, hourEnd: 19, multiplier: "1.15" },
  { hours: "20 - 21", hourStart: 20, hourEnd: 21, multiplier: "1.1" },
  { hours: "22 - 23", hourStart: 22, hourEnd: 23, multiplier: "1.2" },
];

const TABLE_CONFIGS = [
  { key: "baseRates", heading: "Base Rates", render: "renderBaseRatesTable" },
  {
    key: "weightTiers",
    heading: "Weight Tiers",
    render: "renderWeightTiersTable",
  },
  {
    key: "itemClasses",
    heading: "Item Classes",
    render: "renderItemClassesTable",
  },
  { key: "urgency", heading: "Urgency", render: "renderUrgencyTable" },
  {
    key: "vehicleTypes",
    heading: "Vehicle Types",
    render: "renderVehicleTypesTable",
  },
  { key: "timeOfDay", heading: "Time Of Day", render: "renderTimeOfDayTable" },
];

class PriceRecommendation extends Component {
  constructor(props) {
    super(props);
    const baseRates = this.initBaseRates();
    this.state = {
      loading: false,
      searchText: "",
      filterCountry: "",
      showAddCountryModal: false,
      countries: [...DEFAULT_COUNTRIES],
      baseRates,
      weightTiers: this.cloneRows(DEFAULT_WEIGHT_TIERS_ROWS),
      itemClasses: this.cloneRows(DEFAULT_ITEM_CLASSES_ROWS),
      urgency: this.cloneRows(DEFAULT_URGENCY_ROWS),
      vehicleTypes: this.cloneRows(DEFAULT_VEHICLE_TYPES_ROWS),
      timeOfDay: this.cloneRows(DEFAULT_TIME_OF_DAY_ROWS),
      editingCell: null,
      baseRateConfigIds: {},
      baseDistanceData: this._baseDistanceData || {},
      rateMinuteData: this._rateMinuteData || {},
      distanceUnits: ["Km", "Miles"],
      hasChanges: false,
      editedCells: {},
      showUpdateConfirmModal: false,
    };
  }

  componentDidMount() {
    if (getLocalStorage("adminInfo")) {
      if (this.props.countriesRedux && this.props.countriesRedux.length > 0) {
        this.deriveDistanceUnits(this.props.countriesRedux);
      } else {
        this.props.fetchCountries();
      }
      this.fetchAllData();
    } else {
      this.props.history.push("/login");
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.countriesRedux !== this.props.countriesRedux) {
      this.deriveDistanceUnits(this.props.countriesRedux);
    }
  }

  deriveDistanceUnits(countries) {
    if (!countries || countries.length === 0) return;
    this.setState((prev) => {
      const baseDistanceData = { ...prev.baseDistanceData };
      countries.forEach((c) => {
        if (c.distanceUnit && baseDistanceData[c.code]) {
          baseDistanceData[c.code] = {
            ...baseDistanceData[c.code],
            unit: normalizeDistanceUnit(c.distanceUnit),
          };
        }
      });
      return { distanceUnits: ["Km", "Miles"], baseDistanceData };
    });
  }

  cloneRows(rows) {
    return rows.map((r) => ({ ...r }));
  }

  initBaseRates() {
    const rows = this.cloneRows(DEFAULT_BASE_RATES_ROWS);
    const baseDistanceData = {};
    const rateMinuteData = {};
    DEFAULT_COUNTRIES.forEach((c) => {
      rows[0].values[c.code] = "500";
      rows[1].values[c.code] = "100";
      rows[2].values[c.code] = "2";
      rows[3].values[c.code] = c.code === "NG" ? "500" : "5.00";
      rows[4].values[c.code] = "0.70";
      rows[5].values[c.code] = "1.30";
      rows[6].values[c.code] = c.code === "NG" ? "50" : "0.50";
      rows[7].values[c.code] = c.code === "NG" ? "1.2" : "0.6";
      baseDistanceData[c.code] = {
        value: "100",
        unit: c.code === "NG" ? "Km" : "Miles",
      };
      rateMinuteData[c.code] = { value: "2", unit: "min" };
    });
    this._baseDistanceData = baseDistanceData;
    this._rateMinuteData = rateMinuteData;
    return rows;
  }

  addCountryToDefaults(country) {
    this.setState((prev) => {
      const countries = [...prev.countries, country];
      const baseRates = prev.baseRates.map((row, i) => {
        const newRow = { ...row, values: { ...row.values } };
        switch (i) {
          case 0:
            newRow.values[country.code] = "0";
            break;
          case 1:
            newRow.values[country.code] = "0";
            break;
          case 2:
            newRow.values[country.code] = "0";
            break;
          case 3:
            newRow.values[country.code] = "0";
            break;
          case 4:
            newRow.values[country.code] = "0.70";
            break;
          case 5:
            newRow.values[country.code] = "1.30";
            break;
          case 6:
            newRow.values[country.code] = "0";
            break;
          case 7:
            newRow.values[country.code] = "1.00";
            break;
          default:
            break;
        }
        return newRow;
      });
      const baseDistanceData = {
        ...prev.baseDistanceData,
        [country.code]: {
          value: "0",
          unit: normalizeDistanceUnit(country.distanceUnit || "Km"),
        },
      };
      const rateMinuteData = {
        ...prev.rateMinuteData,
        [country.code]: { value: "0", unit: "min" },
      };
      return { countries, baseRates, baseDistanceData, rateMinuteData };
    });
  }

  fetchAllData() {
    this.setState({ loading: true });
    const { filterCountry } = this.state;
    const currency = filterCountry
      ? this.state.countries.find((c) => c.code === filterCountry)?.currency ||
        ""
      : "";

    Promise.all([
      delivaApiService("getPriceBaseRates", { currency: currency || "" }),
      delivaApiService("getPriceWeightTiers", { currency: currency || "" }),
      delivaApiService("getPriceFactors", { type: "ITEM_CLASS" }),
      delivaApiService("getPriceFactors", { type: "URGENCY" }),
      delivaApiService("getPriceFactors", { type: "VEHICLE_TYPE" }),
      delivaApiService("getPriceFactors", { type: "TIME_OF_DAY" }),
      delivaApiService("getPriceVehicleTypes", {}),
    ])
      .then(
        ([
          baseRatesRes,
          weightTiersRes,
          itemClassRes,
          urgencyRes,
          vehicleTypeRes,
          timeOfDayRes,
          vehicleTypesRes,
        ]) => {
          this.processBaseRates(baseRatesRes);
          this.processWeightTiers(weightTiersRes);
          this.processItemClasses(itemClassRes);
          this.processUrgency(urgencyRes);
          this.processTimeOfDay(timeOfDayRes);
          this.processVehicleTypes(vehicleTypesRes, vehicleTypeRes);
          this.setState({ loading: false });
        },
      )
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  processBaseRates(res) {
    const rd = res && res.data && res.data.resourceData;
    if (!rd) return;
    const items = Array.isArray(rd) ? rd : [rd];
    if (items.length === 0) return;

    // Currency fallback map for dynamic resolution
    const CURRENCY_COUNTRY_MAP = {
      INR: { code: "IN", name: "India" },
      NGN: { code: "NG", name: "Nigeria" },
      USD: { code: "US", name: "United States" },
      GHS: { code: "GH", name: "Ghana" },
      CAD: { code: "CA", name: "Canada" },
      GBP: { code: "GB", name: "United Kingdom" },
      EUR: { code: "EU", name: "Europe" },
      KES: { code: "KE", name: "Kenya" },
      ZAR: { code: "ZA", name: "South Africa" },
    };

    let updatedCountries = [...this.state.countries];

    items.forEach((item) => {
      const scopeKey = (item.scopeKey || "").trim();
      const currency = (item.currency || "").trim().toUpperCase();

      // Look up via Redux countries list
      const matchedReduxCountry = (this.props.countriesRedux || []).find(
        (rc) =>
          (scopeKey &&
            scopeKey.toUpperCase() !== "GLOBAL" &&
            (rc.name?.toLowerCase() === scopeKey.toLowerCase() ||
              rc.countryCode?.toLowerCase() === scopeKey.toLowerCase())) ||
          (currency && rc.currency?.toUpperCase() === currency),
      );

      // Fallback via Currency Map
      const currencyFallback = CURRENCY_COUNTRY_MAP[currency];

      let countryCode =
        matchedReduxCountry?.countryCode ||
        currencyFallback?.code ||
        (scopeKey && scopeKey.toUpperCase() !== "GLOBAL"
          ? scopeKey.length === 2
            ? scopeKey.toUpperCase()
            : currency.slice(0, 2)
          : currency.slice(0, 2));

      let countryName =
        matchedReduxCountry?.name ||
        currencyFallback?.name ||
        (scopeKey && scopeKey.toUpperCase() !== "GLOBAL"
          ? scopeKey
          : countryCode);

      // Prevent "GLOBAL" as a country name
      if (countryName.toUpperCase() === "GLOBAL" && currencyFallback) {
        countryName = currencyFallback.name;
        countryCode = currencyFallback.code;
      }

      const exists = updatedCountries.some(
        (c) =>
          c.code.toLowerCase() === countryCode?.toLowerCase() ||
          c.name.toLowerCase() === countryName?.toLowerCase(),
      );

      if (!exists && countryCode && countryCode.toUpperCase() !== "GLOBAL") {
        updatedCountries.push({
          code: countryCode,
          name: countryName,
          currency: currency,
          distanceUnit: normalizeDistanceUnit(item.distanceUnit || "Km"),
        });
      }
    });

    const globalByCurrency = {};
    const countryByCode = {};
    const countryByName = {};

    items.forEach((item) => {
      const curr = (item.currency || "").trim().toUpperCase();
      if ((item.scope || "").toUpperCase() === "GLOBAL") {
        if (curr) {
          globalByCurrency[curr] = item;
        }
      } else if ((item.scope || "").toUpperCase() === "COUNTRY") {
        const key = (item.scopeKey || "").trim().toLowerCase();
        if (key && key !== "global") {
          countryByCode[key] = item;
          countryByName[key] = item;
        }
        if (curr) {
          countryByCode[curr.toLowerCase()] = item;
        }
      }
    });

    const globalCfg =
      globalByCurrency["NGN"] ||
      globalByCurrency["USD"] ||
      Object.values(globalByCurrency)[0];

    const baseRateConfigIds = { ...this.state.baseRateConfigIds };
    const baseRates = this.state.baseRates.map((row) => ({
      ...row,
      values: { ...row.values },
    }));
    const baseDistanceData = { ...this.state.baseDistanceData };
    const rateMinuteData = { ...this.state.rateMinuteData };

    const applyCfg = (c, cfg) => {
      if (!cfg) return;
      const code = c.code;

      if (cfg.pricingConfigId) {
        baseRateConfigIds[code] = cfg.pricingConfigId;
      }
      baseRates[0].values[code] =
        cfg.baseFare != null ? String(cfg.baseFare) : "0";
      baseRates[1].values[code] =
        cfg.ratePerDistance != null ? String(cfg.ratePerDistance) : "0";
      baseRates[2].values[code] =
        cfg.ratePerMinute != null ? String(cfg.ratePerMinute) : "0";
      baseRates[3].values[code] =
        cfg.minimumFare != null ? String(cfg.minimumFare) : "0";
      baseRates[4].values[code] =
        cfg.rangeLowMultiplier != null ? String(cfg.rangeLowMultiplier) : "0";
      baseRates[5].values[code] =
        cfg.rangeHighMultiplier != null ? String(cfg.rangeHighMultiplier) : "0";
      baseRates[6].values[code] =
        cfg.roundingUnit != null ? String(cfg.roundingUnit) : "0";
      baseRates[7].values[code] =
        cfg.locationMultiplier != null
          ? String(cfg.locationMultiplier)
          : "1.00";

      const resolvedUnit = normalizeDistanceUnit(
        cfg.distanceUnit ||
          getDistanceUnit(c.currency, this.props.countriesRedux) ||
          (c.code === "US" ? "Miles" : "Km"),
      );

      baseDistanceData[code] = {
        value: cfg.ratePerDistance != null ? String(cfg.ratePerDistance) : "0",
        unit: resolvedUnit,
      };
      rateMinuteData[code] = {
        value: cfg.ratePerMinute != null ? String(cfg.ratePerMinute) : "0",
        unit: "min",
      };
    };

    const findCfg = (c) => {
      return (
        countryByName[c.name.toLowerCase()] ||
        countryByCode[c.code.toLowerCase()] ||
        (c.currency ? countryByCode[c.currency.toLowerCase()] : null) ||
        (c.currency ? globalByCurrency[c.currency.toUpperCase()] : null) ||
        globalCfg
      );
    };

    if (!this.state.filterCountry) {
      if (globalCfg) {
        baseRateConfigIds["GLOBAL"] = globalCfg.pricingConfigId;
      }
      updatedCountries.forEach((c) => {
        const cfg = findCfg(c);
        applyCfg(c, cfg);
      });
    } else {
      const selectedCountry = updatedCountries.find(
        (c) => c.code === this.state.filterCountry,
      );
      if (selectedCountry) {
        const cfg = findCfg(selectedCountry);
        applyCfg(selectedCountry, cfg);
      }
    }

    this.setState({
      countries: updatedCountries,
      baseRates,
      baseRateConfigIds,
      baseDistanceData,
      rateMinuteData,
    });
  }

  processWeightTiers(res) {
    const rd = res && res.data && res.data.resourceData;
    if (!rd) return;
    const items = Array.isArray(rd) ? rd : [rd];
    if (items.length === 0) return;

    const weightTiers = items
      .sort((a, b) => {
        if (a.currency !== b.currency) return a.currency > b.currency ? 1 : -1;
        return (a.sortOrder || 0) - (b.sortOrder || 0);
      })
      .map((item) => ({
        weightTierId: item.weightTierId,
        currency: item.currency,
        from: String(item.minWeight != null ? item.minWeight : "0"),
        to:
          item.maxWeight != null
            ? String(item.maxWeight)
            : `${item.minWeight != null ? item.minWeight : "0"}+`,
        unit: (() => {
          const rc = (this.props.countriesRedux || []).find(
            (c) => c.currency === item.currency,
          );
          return (
            rc?.weightUnit ||
            (normalizeDistanceUnit(rc?.distanceUnit || "Km") === "Miles"
              ? "LBS"
              : "KG")
          ).toLowerCase();
        })(),
        baseRate: String(item.ratePerUnit != null ? item.ratePerUnit : "0"),
      }));

    this.setState({ weightTiers });
  }

  processItemClasses(res) {
    const rd = res && res.data && res.data.resourceData;
    if (!rd) return;
    const items = Array.isArray(rd) ? rd : [rd];
    if (items.length === 0) return;

    const itemClasses = items.map((item) => ({
      factorMultiplierId: item.factorMultiplierId,
      className: item.factorKey || "",
      multiplier: String(item.multiplier != null ? item.multiplier : "1"),
    }));

    this.setState({ itemClasses });
  }

  processUrgency(res) {
    const rd = res && res.data && res.data.resourceData;
    if (!rd) return;
    const items = Array.isArray(rd) ? rd : [rd];
    if (items.length === 0) return;

    const urgency = items.map((item) => ({
      factorMultiplierId: item.factorMultiplierId,
      urgency: item.factorKey || "",
      multiplier: String(item.multiplier != null ? item.multiplier : "1"),
    }));

    this.setState({ urgency });
  }

  processTimeOfDay(res) {
    const rd = res && res.data && res.data.resourceData;
    if (!rd) return;
    const items = Array.isArray(rd) ? rd : [rd];
    if (items.length === 0) return;

    const timeOfDay = items
      .sort((a, b) => (a.hourStart || 0) - (b.hourStart || 0))
      .map((item) => ({
        factorMultiplierId: item.factorMultiplierId,
        label: item.factorKey || "",
        factorKey:
          item.factorKey || `HOURS_${item.hourStart || 0}_${item.hourEnd || 0}`,
        hours: `${item.hourStart != null ? item.hourStart : 0} - ${item.hourEnd != null ? item.hourEnd : 0}`,
        hourStart: item.hourStart != null ? item.hourStart : 0,
        hourEnd: item.hourEnd != null ? item.hourEnd : 0,
        multiplier: String(item.multiplier != null ? item.multiplier : "1"),
      }));

    this.setState({ timeOfDay });
  }

  processVehicleTypes(catalogRes, factorRes) {
    const catalogRd =
      catalogRes && catalogRes.data && catalogRes.data.resourceData;
    const factorRd = factorRes && factorRes.data && factorRes.data.resourceData;

    const catalogItems = catalogRd
      ? Array.isArray(catalogRd)
        ? catalogRd
        : [catalogRd]
      : [];
    const factorItems = factorRd
      ? Array.isArray(factorRd)
        ? factorRd
        : [factorRd]
      : [];

    if (catalogItems.length === 0 && factorItems.length === 0) return;

    const defaultMaxWeight = {};
    DEFAULT_VEHICLE_TYPES_ROWS.forEach((d) => {
      const norm = d.vehicleType.replace(/\s+/g, "_").toUpperCase();
      defaultMaxWeight[norm] = d.maxWeight;
    });

    const vehicleTypeOrder = DEFAULT_VEHICLE_TYPES_ROWS.map((d) =>
      d.vehicleType.replace(/\s+/g, "_").toUpperCase(),
    );

    const sortByDefaultOrder = (arr) => {
      arr.sort((a, b) => {
        const aKey = a.vehicleType.replace(/\s+/g, "_").toUpperCase();
        const bKey = b.vehicleType.replace(/\s+/g, "_").toUpperCase();
        const aIdx = vehicleTypeOrder.indexOf(aKey);
        const bIdx = vehicleTypeOrder.indexOf(bKey);
        const aPos = aIdx >= 0 ? aIdx : vehicleTypeOrder.length;
        const bPos = bIdx >= 0 ? bIdx : vehicleTypeOrder.length;
        return aPos - bPos;
      });
    };

    let vehicleTypes = [];
    if (catalogItems.length > 0) {
      const factorByKey = {};
      factorItems.forEach((f) => {
        factorByKey[f.factorKey] = f;
      });
      vehicleTypes = catalogItems.map((item) => {
        const key = (item.vehicleType || item.code || "")
          .replace(/\s+/g, "_")
          .toUpperCase();
        const factor = factorByKey[key];
        return {
          vehicleTypeId: item.id,
          factorMultiplierId: factor ? factor.factorMultiplierId : null,
          vehicleType: item.vehicleType || item.code || "",
          multiplier: String(
            factor
              ? factor.multiplier
              : item.multiplier != null
                ? item.multiplier
                : "1",
          ),
          maxWeight:
            item.maxWeightKg != null ? String(item.maxWeightKg) : "\u2014",
        };
      });
    } else {
      vehicleTypes = factorItems
        .filter((f) => f.factorKey && f.factorKey.toUpperCase() !== "UNKNOWN")
        .map((f) => {
          const key = f.factorKey.replace(/\s+/g, "_").toUpperCase();
          return {
            vehicleTypeId: null,
            factorMultiplierId: f.factorMultiplierId,
            vehicleType: f.factorKey.replace(/_/g, " "),
            multiplier: String(f.multiplier != null ? f.multiplier : "1"),
            maxWeight:
              defaultMaxWeight[key] != null ? defaultMaxWeight[key] : "\u2014",
          };
        });
    }

    sortByDefaultOrder(vehicleTypes);
    this.setState({ vehicleTypes });
  }

  sanitizeNumericInput = (value) => {
    if (value === undefined || value === null) return "";
    let str = String(value).replace(/[^\d.]/g, "");
    const parts = str.split(".");
    if (parts.length > 2) {
      str = parts[0] + "." + parts.slice(1).join("");
    }
    const dotIdx = str.indexOf(".");
    if (dotIdx !== -1) {
      const intPart = str.slice(0, dotIdx);
      const allowedFrac = 4 - intPart.length;
      str =
        allowedFrac > 0
          ? intPart + "." + str.slice(dotIdx + 1, dotIdx + 1 + allowedFrac)
          : intPart;
    } else if (str.length > 4) {
      str = str.slice(0, 4);
    }
    return str;
  };

  sanitizeIntegerInput = (value) => {
    if (value === undefined || value === null) return "";
    return String(value).replace(/[^\d]/g, "").slice(0, 4);
  };

  updateBaseDistanceValue = (code, value) => {
    const sanitized = this.sanitizeNumericInput(value);
    this.setState((prev) => {
      const baseDistanceData = { ...prev.baseDistanceData };
      baseDistanceData[code] = { ...baseDistanceData[code], value: sanitized };
      const baseRates = [...prev.baseRates];
      baseRates[1] = {
        ...baseRates[1],
        values: { ...baseRates[1].values, [code]: sanitized },
      };
      const editedCells = { ...prev.editedCells };
      editedCells[`baseRates_1`] = true;
      return { baseDistanceData, baseRates, hasChanges: true, editedCells };
    });
  };

  updateBaseDistanceUnit = (code, unit) => {
    this.setState((prev) => {
      const baseDistanceData = { ...prev.baseDistanceData };
      baseDistanceData[code] = {
        ...baseDistanceData[code],
        unit: normalizeDistanceUnit(unit),
      };
      const editedCells = { ...prev.editedCells };
      editedCells[`baseRates_1`] = true;
      return { baseDistanceData, hasChanges: true, editedCells };
    });
  };

  updateRateMinuteValue = (code, value) => {
    const sanitized = this.sanitizeNumericInput(value);
    this.setState((prev) => {
      const rateMinuteData = { ...prev.rateMinuteData };
      rateMinuteData[code] = { ...rateMinuteData[code], value: sanitized };
      const baseRates = [...prev.baseRates];
      baseRates[2] = {
        ...baseRates[2],
        values: { ...baseRates[2].values, [code]: sanitized },
      };
      const editedCells = { ...prev.editedCells };
      editedCells[`baseRates_2`] = true;
      return { rateMinuteData, baseRates, hasChanges: true, editedCells };
    });
  };

  startEdit = (table, rowIndex) => {
    this.setState({ editingCell: { table, rowIndex } });
  };

  finishEdit = () => {
    this.setState({ editingCell: null });
  };

  updateCellValue = (table, rowIndex, field, value) => {
    const isKgWeightTierRate =
      table === "weightTiers" &&
      field === "baseRate" &&
      this.state.weightTiers?.[rowIndex]?.unit === "kg";
    const sanitized = isKgWeightTierRate
      ? this.sanitizeIntegerInput(value)
      : this.sanitizeNumericInput(value);
    this.setState((prev) => {
      const data = [...prev[table]];
      const row = { ...data[rowIndex] };
      if (field.startsWith("values.")) {
        const code = field.split(".")[1];
        row.values = { ...row.values, [code]: sanitized };
      } else {
        row[field] = sanitized;
      }
      data[rowIndex] = row;
      const editedCells = { ...prev.editedCells };
      editedCells[`${table}_${rowIndex}`] = true;
      return { [table]: data, hasChanges: true, editedCells };
    });
  };

  handleUpdateAll = async () => {
    const {
      countries,
      baseRates,
      weightTiers,
      itemClasses,
      urgency,
      vehicleTypes,
      timeOfDay,
      baseRateConfigIds,
      filterCountry,
      baseDistanceData,
      rateMinuteData,
      editedCells,
    } = this.state;

    this.setState({ loading: true, hasChanges: false, editedCells: {} });

    const hasAnyBaseRateEdit = (code) => {
      for (let i = 0; i <= 7; i += 1) {
        if (editedCells[`baseRates_${i}`]) return true;
      }
      return false;
    };

    const safeNum = (val) => {
      if (val === undefined || val === null || val === "") return "0";
      const parsed = parseFloat(val);
      return isNaN(parsed) ? "0" : String(parsed);
    };

    const isValidMultiplier = (val) => {
      const num = parseFloat(val);
      return !isNaN(num) && num > 0;
    };

    // 1. Build Base Rate Tasks
    const baseRateTasks = [];
    if (!filterCountry) {
      const countriesToUpdate = countries.filter((c) =>
        hasAnyBaseRateEdit(c.code),
      );
      countriesToUpdate
        .filter((c) => baseRateConfigIds[c.code])
        .forEach((c) => {
          const code = c.code;
          const fareVal = baseRates[0].values[code] || "";
          const dd = baseDistanceData[code] || {};
          const distVal =
            dd.value !== undefined ? dd.value : baseRates[1].values[code] || "";
          const distUnit = normalizeDistanceUnit(dd.unit) || "Km";
          const rd = rateMinuteData[code] || {};
          const rateMinVal =
            rd.value !== undefined ? rd.value : baseRates[2].values[code] || "";
          const minFareVal = baseRates[3].values[code] || "";
          const rangeLowVal = baseRates[4].values[code] || "";
          const rangeHighVal = baseRates[5].values[code] || "";
          const roundVal = baseRates[6].values[code] || "";
          const countryMultiplierVal = baseRates[7].values[code] || "";

          baseRateTasks.push({
            action: "updatePriceBaseRate",
            payload: {
              id: baseRateConfigIds[code],
              scope: "COUNTRY",
              scopeKey: c.name,
              currency: c.currency,
              baseFare: safeNum(fareVal),
              ratePerDistance: safeNum(distVal),
              ratePerMinute: safeNum(rateMinVal),
              minimumFare: safeNum(minFareVal),
              maximumFare: "0",
              roundingUnit: safeNum(roundVal),
              rangeLowMultiplier: safeNum(rangeLowVal),
              rangeHighMultiplier: safeNum(rangeHighVal),
              locationMultiplier: safeNum(countryMultiplierVal),
              roadFactor: "0",
              averageSpeedKmph: "0",
              distanceUnit: distUnit,
              weightUnit: (() => {
                const rc = (this.props.countriesRedux || []).find(
                  (x) => x.currency === c.currency,
                );
                return (
                  rc?.weightUnit ||
                  (normalizeDistanceUnit(rc?.distanceUnit || "Km") === "Miles"
                    ? "LBS"
                    : "KG")
                );
              })(),
              active: true,
            },
          });
        });
    } else {
      const selectedCountry = countries.find((c) => c.code === filterCountry);
      if (selectedCountry && baseRateConfigIds[filterCountry]) {
        const code = filterCountry;
        const fareVal = baseRates[0].values[code] || "";
        const dd = baseDistanceData[code] || {};
        const distVal =
          dd.value !== undefined ? dd.value : baseRates[1].values[code] || "";
        const distUnit = normalizeDistanceUnit(dd.unit) || "Km";
        const rd = rateMinuteData[code] || {};
        const rateMinVal =
          rd.value !== undefined ? rd.value : baseRates[2].values[code] || "";
        const minFareVal = baseRates[3].values[code] || "";
        const rangeLowVal = baseRates[4].values[code] || "";
        const rangeHighVal = baseRates[5].values[code] || "";
        const roundVal = baseRates[6].values[code] || "";
        const countryMultiplierVal = baseRates[7].values[code] || "";

        baseRateTasks.push({
          action: "updatePriceBaseRate",
          payload: {
            id: baseRateConfigIds[filterCountry],
            scope: "COUNTRY",
            scopeKey: selectedCountry.name,
            currency: selectedCountry.currency,
            baseFare: safeNum(fareVal),
            ratePerDistance: safeNum(distVal),
            ratePerMinute: safeNum(rateMinVal),
            minimumFare: safeNum(minFareVal),
            maximumFare: "0",
            roundingUnit: safeNum(roundVal),
            rangeLowMultiplier: safeNum(rangeLowVal),
            rangeHighMultiplier: safeNum(rangeHighVal),
            locationMultiplier: safeNum(countryMultiplierVal),
            roadFactor: "0",
            averageSpeedKmph: "0",
            distanceUnit: distUnit,
            weightUnit: (() => {
              const rc = (this.props.countriesRedux || []).find(
                (x) => x.currency === selectedCountry.currency,
              );
              return (
                rc?.weightUnit ||
                (normalizeDistanceUnit(rc?.distanceUnit || "Km") === "Miles"
                  ? "LBS"
                  : "KG")
              );
            })(),
            active: true,
          },
        });
      }
    }

    // 2. Build Weight Tier Tasks
    const editedWeightTiers = weightTiers.filter(
      (row, idx) => editedCells[`weightTiers_${idx}`] && row.weightTierId,
    );
    const weightTierCurrency =
      editedWeightTiers[0]?.currency ||
      (filterCountry
        ? countries.find((c) => c.code === filterCountry)?.currency
        : undefined) ||
      weightTiers[0]?.currency ||
      "NGN";

    const weightTierTasks = editedWeightTiers.map((row) => ({
      action: "updatePriceWeightTier",
      payload: {
        id: row.weightTierId,
        currency: row.currency || weightTierCurrency,
        minWeight: String(safeNum(row.from) ?? 0),
        maxWeight:
          row.to === "50+" || row.to === "\u2014"
            ? null
            : String(safeNum(row.to) ?? 0),
        ratePerUnit: String(safeNum(row.baseRate) ?? 0),
        sortOrder: "0",
        active: true,
      },
    }));

    // 3. Build Factors Tasks (Item Classes, Urgency, Time Of Day)
    const factorTasks = [
      ...itemClasses
        .filter(
          (row, idx) =>
            editedCells[`itemClasses_${idx}`] && row.factorMultiplierId,
        )
        .map((row) => ({
          action: "updatePriceFactor",
          payload: {
            id: row.factorMultiplierId,
            factorType: "ITEM_CLASS",
            factorKey: row.className,
            multiplier: safeNum(row.multiplier),
            hourStart: "0",
            hourEnd: "0",
            active: true,
          },
        })),
      ...urgency
        .filter(
          (row, idx) => editedCells[`urgency_${idx}`] && row.factorMultiplierId,
        )
        .map((row) => ({
          action: "updatePriceFactor",
          payload: {
            id: row.factorMultiplierId,
            factorType: "URGENCY",
            factorKey: row.urgency,
            multiplier: safeNum(row.multiplier),
            hourStart: "0",
            hourEnd: "0",
            active: true,
          },
        })),
      ...timeOfDay
        .filter(
          (row, idx) =>
            editedCells[`timeOfDay_${idx}`] && row.factorMultiplierId,
        )
        .map((row) => ({
          action: "updatePriceFactor",
          payload: {
            id: row.factorMultiplierId,
            factorType: "TIME_OF_DAY",
            factorKey: row.factorKey || `HOURS_${row.hourStart}_${row.hourEnd}`,
            hourStart: String(parseInt(row.hourStart, 10) || "0"),
            hourEnd: String(parseInt(row.hourEnd, 10) || "0"),
            multiplier: safeNum(row.multiplier),
            active: true,
          },
        })),
    ];

    // 4. Build Vehicle Type Tasks
    const vehicleTasks = vehicleTypes
      .filter(
        (v, idx) =>
          v.vehicleType &&
          v.vehicleType !== "Any heavy duty vehicle type" &&
          editedCells[`vehicleTypes_${idx}`] &&
          v.vehicleTypeId,
      )
      .map((row) => ({
        action: "updatePriceVehicleType",
        payload: {
          id: row.vehicleTypeId,
          code: row.vehicleType.replace(/\s+/g, "_"),
          vehicleType: row.vehicleType.replace(/\s+/g, "_"),
          displayName: row.vehicleType,
          wheels: "4",
          maxWeightKg: safeNum(row.maxWeight),
          sortOrder: "0",
          imageUrl: null,
          multiplier: safeNum(row.multiplier),
          active: true,
        },
      }));

    const allTasks = [
      ...baseRateTasks,
      ...weightTierTasks,
      ...factorTasks,
      ...vehicleTasks,
    ];

    const hasInvalidMultiplier = (tasks) =>
      tasks.some((task) => {
        const p = task.payload;
        if (task.action === "updatePriceBaseRate") {
          return (
            !isValidMultiplier(p.rangeLowMultiplier) ||
            !isValidMultiplier(p.rangeHighMultiplier) ||
            !isValidMultiplier(p.locationMultiplier)
          );
        }
        if (
          task.action === "updatePriceFactor" ||
          task.action === "updatePriceVehicleType"
        ) {
          return !isValidMultiplier(p.multiplier);
        }
        return false;
      });

    if (
      hasInvalidMultiplier(baseRateTasks) ||
      hasInvalidMultiplier(factorTasks) ||
      hasInvalidMultiplier(vehicleTasks)
    ) {
      showErrorToast(
        "All multiplier values are required and must be greater than 0.",
      );
      this.setState({ hasChanges: true, loading: false });
      return;
    }

    if (allTasks.length === 0) {
      showSuccessToast("No changes to update.");
      this.setState({ loading: false });
      return;
    }

    try {
      for (const task of allTasks) {
        await delivaApiService(task.action, task.payload);
      }
      showSuccessToast("Pricing configuration updated successfully.");
      this.setState({ loading: false }, () => {
        this.fetchAllData();
      });
    } catch (err) {
      showErrorToast("Some updates failed. Please try again.");
      this.setState({ loading: false });
    }
  };

  handleAddCountry = async (country) => {
    const { countriesRedux } = this.props;
    let reduxCountry = countriesRedux.find(
      (c) => c.countryCode === country.code,
    );

    try {
      const freshRes = await delivaApiService("getCountriesWithUnits", {});
      const freshData =
        freshRes?.data?.resourceData ||
        freshRes?.data?.resourceData?.data ||
        [];
      const freshCountry = Array.isArray(freshData)
        ? freshData.find(
            (c) =>
              (c.countryCode || "") === country.code ||
              (c.currency || "").toUpperCase() ===
                country.currency.toUpperCase(),
          )
        : freshData;
      reduxCountry = freshCountry || reduxCountry;
    } catch (_) {}

    const isLbs = (() => {
      const raw = String(reduxCountry?.weightUnit || "")
        .trim()
        .toUpperCase();
      if (["LBS", "LB", "LBM", "POUND", "POUNDS", "IMPERIAL"].includes(raw)) {
        return true;
      }
      if (["KG", "KGM", "KILOGRAM", "KILOGRAMS"].includes(raw)) {
        return false;
      }
      return (
        normalizeDistanceUnit(reduxCountry?.distanceUnit || "Km") === "Miles"
      );
    })();

    const basePayload = {
      currency: country.currency,
      baseFare: "500",
      ratePerDistance: "120",
      ratePerMinute: "15",
      minimumFare: "1500",
      maximumFare: "0",
      roundingUnit: "50",
      rangeLowMultiplier: "0.8",
      rangeHighMultiplier: "1.5",
      roadFactor: "1.3",
      averageSpeedKmph: "30",
      distanceUnit: normalizeDistanceUnit(reduxCountry?.distanceUnit || "Km"),
      weightUnit: isLbs ? "LBS" : "KG",
      active: true,
    };

    const countryPayload = {
      ...basePayload,
      scope: "COUNTRY",
      scopeKey: country.name,
    };

    this.setState({ loading: true });
    try {
      const [countryRes] = await Promise.all([
        delivaApiService("createPriceBaseRate", countryPayload),
      ]);
      const countryConfigId =
        countryRes?.data?.id || countryRes?.data?.pricingConfigId;
      const refCurrency = isLbs ? "USD" : "NGN";

      try {
        const refWeightRes = await delivaApiService("getPriceWeightTiers", {
          currency: refCurrency,
        });
        const refTiers =
          refWeightRes?.data?.resourceData ||
          refWeightRes?.data?.resourceData?.data ||
          [];

        if (refTiers.length > 0) {
          for (const tier of refTiers) {
            const { minWeight, maxWeight, ratePerUnit, sortOrder } = tier;
            await delivaApiService("createPriceWeightTier", {
              currency: country.currency,
              minWeight:
                minWeight !== null && minWeight !== undefined
                  ? String(minWeight)
                  : "0",
              maxWeight:
                maxWeight !== null && maxWeight !== undefined
                  ? String(maxWeight)
                  : null,
              ratePerUnit:
                ratePerUnit !== null && ratePerUnit !== undefined
                  ? String(ratePerUnit)
                  : "0",
              sortOrder:
                sortOrder !== null && sortOrder !== undefined
                  ? String(sortOrder)
                  : "0",
              active: true,
            });
          }
        }
      } catch (e) {
        console.warn("Failed to create weight tiers for", country.currency, e);
      }

      this.setState(
        (prev) => {
          const ids = { ...prev.baseRateConfigIds };
          if (countryConfigId) ids[country.code] = countryConfigId;
          const countries = [...prev.countries, country];
          return {
            countries,
            baseRateConfigIds: ids,
            showAddCountryModal: false,
            hasChanges: false,
          };
        },
        () => {
          this.fetchAllData();
        },
      );
    } catch (err) {
      this.setState({ loading: false });
      showErrorToast(`Failed to add ${country.name}. Please try again.`);
    }
  };

  handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.fetchAllData();
    }
  };

  handleUpdateConfirm = () => {
    this.setState({ showUpdateConfirmModal: true });
  };

  handleConfirmUpdate = () => {
    this.setState({ showUpdateConfirmModal: false }, () => {
      this.handleUpdateAll();
    });
  };

  handleCloseUpdateConfirm = () => {
    this.setState({ showUpdateConfirmModal: false });
  };

  // ── Render tables ──────────────────────────────────────────────────────

  renderBaseRatesTable() {
    const {
      baseRates,
      countries,
      editingCell,
      filterCountry,
      baseDistanceData,
      rateMinuteData,
    } = this.state;
    const displayCountries = filterCountry
      ? countries.filter((c) => c.code === filterCountry)
      : countries;

    return (
      <div className="config-section">
        <h5 className="tertiary-color font-weight-normal fs-24 mb-2">
          Base Rates
        </h5>
        <div className="pr-table-scroll">
          <Table responsive>
            <thead>
              <tr>
                <th style={{ verticalAlign: "middle" }}>
                  <div>
                    Parameter <span className="text-danger">*</span>
                  </div>
                </th>
                {displayCountries.map((c) => (
                  <th key={c.code} style={{ verticalAlign: "middle" }}>
                    {c.name}
                  </th>
                ))}
                <th style={{ verticalAlign: "middle" }}>Action</th>
              </tr>
            </thead>
            <tbody className="ttl-order-table">
              {baseRates.map((row, idx) => {
                const isEditing =
                  editingCell &&
                  editingCell.table === "baseRates" &&
                  editingCell.rowIndex === idx;
                return (
                  <tr key={idx}>
                    <td>{row.parameter}</td>
                    {displayCountries.map((c) => {
                      if (isEditing && idx === 1) {
                        const dd = baseDistanceData[c.code] || {
                          value: "0",
                          unit: normalizeDistanceUnit(
                            getDistanceUnit(
                              c.currency,
                              this.props.countriesRedux,
                            ) || (c.code === "US" ? "Miles" : "Km"),
                          ),
                        };

                        const selectedUnit = normalizeDistanceUnit(dd.unit);

                        return (
                          <td key={c.code} className="pr-editing">
                            <div className="d-flex align-items-center">
                              <input
                                className="form-control"
                                type="number"
                                min="0"
                                value={dd.value}
                                onChange={(e) =>
                                  this.updateBaseDistanceValue(
                                    c.code,
                                    e.target.value,
                                  )
                                }
                                style={{ maxWidth: "120px" }}
                              />
                              <span className="ml-2 text-muted">
                                {selectedUnit}
                              </span>
                            </div>
                          </td>
                        );
                      }
                      if (isEditing && idx === 2) {
                        const rd = rateMinuteData[c.code] || {
                          value: "0",
                          unit: "min",
                        };
                        return (
                          <td key={c.code} className="pr-editing">
                            <div className="d-flex align-items-center">
                              <input
                                className="form-control"
                                type="number"
                                min="0"
                                step="0.01"
                                value={rd.value}
                                onChange={(e) =>
                                  this.updateRateMinuteValue(
                                    c.code,
                                    e.target.value,
                                  )
                                }
                                style={{ maxWidth: "120px" }}
                              />
                              <span className="ml-2 text-muted">min</span>
                            </div>
                          </td>
                        );
                      }
                      let displayVal = row.values[c.code] || "\u2014";
                      if (idx === 1 && baseDistanceData[c.code]) {
                        const dd = baseDistanceData[c.code];
                        const unitLabel = normalizeDistanceUnit(
                          dd.unit ||
                            getDistanceUnit(
                              c.currency,
                              this.props.countriesRedux,
                            ) ||
                            (c.code === "US" ? "Miles" : "Km"),
                        );
                        displayVal =
                          dd.value !== ""
                            ? `${dd.value}/${unitLabel}`
                            : "\u2014";
                      } else if (idx === 2 && rateMinuteData[c.code]) {
                        const rd = rateMinuteData[c.code];
                        displayVal =
                          rd.value !== "" ? `${rd.value}/min` : "\u2014";
                      }
                      return (
                        <td
                          key={c.code}
                          className={isEditing ? "pr-editing" : ""}
                        >
                          {isEditing ? (
                            <input
                              className="form-control"
                              type={
                                idx === 4 || idx === 5 || idx === 7
                                  ? "number"
                                  : "text"
                              }
                              min={
                                idx === 4 || idx === 5 || idx === 7
                                  ? "0.01"
                                  : undefined
                              }
                              step={
                                idx === 4 || idx === 5 || idx === 7
                                  ? "0.01"
                                  : undefined
                              }
                              value={row.values[c.code] || ""}
                              onChange={(e) =>
                                this.updateCellValue(
                                  "baseRates",
                                  idx,
                                  `values.${c.code}`,
                                  e.target.value,
                                )
                              }
                            />
                          ) : (
                            displayVal
                          )}
                        </td>
                      );
                    })}
                    <td className="views-icos">
                      {isEditing ? (
                        <button
                          className="btnDefault btnOutline"
                          onClick={this.finishEdit}
                        >
                          DONE
                        </button>
                      ) : (
                        <span
                          title="Edit"
                          className="icon-edit-ico pr-edit-icon"
                          onClick={() => this.startEdit("baseRates", idx)}
                        ></span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }

  renderWeightTiersTable() {
    const { weightTiers, editingCell } = this.state;

    return (
      <div className="config-section">
        <h5 className="tertiary-color font-weight-normal fs-24 mb-2">
          Weight Tiers
        </h5>
        <Table responsive>
          <thead>
            <tr>
              <th>From</th>
              <th>To</th>
              <th>Weight Unit</th>
              <th>
                Rate <span className="text-danger">*</span>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="ttl-order-table">
            {weightTiers.map((row, idx) => {
              const isEditing =
                editingCell &&
                editingCell.table === "weightTiers" &&
                editingCell.rowIndex === idx;
              return (
                <tr key={idx}>
                  <td>{row.from}</td>
                  <td>{row.to}</td>
                  <td>
                    {row.unit} ({row.currency})
                  </td>
                  <td className={isEditing ? "pr-editing" : ""}>
                    {isEditing ? (
                      <input
                        className="form-control"
                        type="number"
                        min={row.unit === "kg" ? "0" : undefined}
                        step={row.unit === "kg" ? "1" : undefined}
                        value={row.baseRate}
                        onChange={(e) =>
                          this.updateCellValue(
                            "weightTiers",
                            idx,
                            "baseRate",
                            e.target.value,
                          )
                        }
                      />
                    ) : (
                      row.baseRate
                    )}
                  </td>
                  <td className="views-icos">
                    {isEditing ? (
                      <button
                        className="btnDefault btnOutline"
                        onClick={this.finishEdit}
                      >
                        DONE
                      </button>
                    ) : (
                      <span
                        title="Edit"
                        className="icon-edit-ico pr-edit-icon"
                        onClick={() => this.startEdit("weightTiers", idx)}
                      ></span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }

  renderItemClassesTable() {
    const { itemClasses, editingCell } = this.state;

    return (
      <div className="config-section">
        <h5 className="tertiary-color font-weight-normal fs-24 mb-2">
          Item Classes
        </h5>
        <Table responsive>
          <thead>
            <tr>
              <th>Class</th>
              <th>
                Multiplier <span className="text-danger">*</span>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="ttl-order-table">
            {itemClasses.map((row, idx) => {
              const isEditing =
                editingCell &&
                editingCell.table === "itemClasses" &&
                editingCell.rowIndex === idx;
              return (
                <tr key={idx}>
                  <td>{row.className?.replace(/_/g, " ")}</td>
                  <td className={isEditing ? "pr-editing" : ""}>
                    {isEditing ? (
                      <input
                        className="form-control"
                        type="number"
                        min="0.01"
                        step="0.01"
                        value={row.multiplier}
                        onChange={(e) =>
                          this.updateCellValue(
                            "itemClasses",
                            idx,
                            "multiplier",
                            e.target.value,
                          )
                        }
                      />
                    ) : (
                      row.multiplier
                    )}
                  </td>
                  <td className="views-icos">
                    {isEditing ? (
                      <button
                        className="btnDefault btnOutline"
                        onClick={this.finishEdit}
                      >
                        DONE
                      </button>
                    ) : (
                      <span
                        title="Edit"
                        className="icon-edit-ico pr-edit-icon"
                        onClick={() => this.startEdit("itemClasses", idx)}
                      ></span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }

  renderUrgencyTable() {
    const { urgency, editingCell } = this.state;

    return (
      <div className="config-section">
        <h5 className="tertiary-color font-weight-normal fs-24 mb-2">
          Urgency
        </h5>
        <Table responsive>
          <thead>
            <tr>
              <th>Urgency</th>
              <th>
                Multiplier <span className="text-danger">*</span>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="ttl-order-table">
            {urgency.map((row, idx) => {
              const isEditing =
                editingCell &&
                editingCell.table === "urgency" &&
                editingCell.rowIndex === idx;
              return (
                <tr key={idx}>
                  <td>{row.urgency}</td>
                  <td className={isEditing ? "pr-editing" : ""}>
                    {isEditing ? (
                      <input
                        className="form-control"
                        type="number"
                        min="0.01"
                        step="0.01"
                        value={row.multiplier}
                        onChange={(e) =>
                          this.updateCellValue(
                            "urgency",
                            idx,
                            "multiplier",
                            e.target.value,
                          )
                        }
                      />
                    ) : (
                      row.multiplier
                    )}
                  </td>
                  <td className="views-icos">
                    {isEditing ? (
                      <button
                        className="btnDefault btnOutline"
                        onClick={this.finishEdit}
                      >
                        DONE
                      </button>
                    ) : (
                      <span
                        title="Edit"
                        className="icon-edit-ico pr-edit-icon"
                        onClick={() => this.startEdit("urgency", idx)}
                      ></span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }

  renderVehicleTypesTable() {
    const { vehicleTypes, editingCell } = this.state;

    return (
      <div className="config-section">
        <h5 className="tertiary-color font-weight-normal fs-24 mb-2">
          Vehicle Types
        </h5>
        <Table responsive>
          <thead>
            <tr>
              <th>Vehicle Types</th>
              <th>
                Multiplier <span className="text-danger">*</span>
              </th>
              <th>Max Weight kg/lbs</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="ttl-order-table">
            {vehicleTypes.map((row, idx) => {
              const isEditing =
                editingCell &&
                editingCell.table === "vehicleTypes" &&
                editingCell.rowIndex === idx;
              return (
                <tr key={idx}>
                  <td>{row.vehicleType?.replace(/_/g, " ")}</td>
                  <td className={isEditing ? "pr-editing" : ""}>
                    {isEditing ? (
                      <input
                        className="form-control"
                        type="number"
                        min="0.01"
                        step="0.1"
                        value={row.multiplier}
                        onChange={(e) =>
                          this.updateCellValue(
                            "vehicleTypes",
                            idx,
                            "multiplier",
                            e.target.value,
                          )
                        }
                      />
                    ) : (
                      row.multiplier
                    )}
                  </td>
                  <td>{row.maxWeight}</td>
                  <td className="views-icos">
                    {isEditing ? (
                      <button
                        className="btnDefault btnOutline"
                        onClick={this.finishEdit}
                      >
                        DONE
                      </button>
                    ) : (
                      <span
                        title="Edit"
                        className="icon-edit-ico pr-edit-icon"
                        onClick={() => this.startEdit("vehicleTypes", idx)}
                      ></span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }

  renderTimeOfDayTable() {
    const { timeOfDay, editingCell } = this.state;

    return (
      <div className="config-section">
        <h5 className="tertiary-color font-weight-normal fs-24 mb-2">
          Time Of Day
        </h5>
        <Table responsive>
          <thead>
            <tr>
              <th>Hours</th>
              <th>
                Multiplier <span className="text-danger">*</span>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="ttl-order-table">
            {timeOfDay.map((row, idx) => {
              const isEditing =
                editingCell &&
                editingCell.table === "timeOfDay" &&
                editingCell.rowIndex === idx;
              return (
                <tr key={idx}>
                  <td>
                    <span>{row.label?.replace(/_/g, " ")}</span>
                    <br />
                    <small className="text-muted">{row.hours}</small>
                  </td>
                  <td className={isEditing ? "pr-editing" : ""}>
                    {isEditing ? (
                      <input
                        className="form-control"
                        type="number"
                        min="0.01"
                        step="0.01"
                        value={row.multiplier}
                        onChange={(e) =>
                          this.updateCellValue(
                            "timeOfDay",
                            idx,
                            "multiplier",
                            e.target.value,
                          )
                        }
                      />
                    ) : (
                      row.multiplier
                    )}
                  </td>
                  <td className="views-icos">
                    {isEditing ? (
                      <button
                        className="btnDefault btnOutline"
                        onClick={this.finishEdit}
                      >
                        DONE
                      </button>
                    ) : (
                      <span
                        title="Edit"
                        className="icon-edit-ico pr-edit-icon"
                        onClick={() => this.startEdit("timeOfDay", idx)}
                      ></span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }

  render() {
    const {
      loading,
      searchText,
      filterCountry,
      countries,
      showAddCountryModal,
    } = this.state;

    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />
        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper">
                  <Loader showLoader={loading} />

                  {/* Page Header */}
                  <div className="pr-page-header-wrap mb-3">
                    <div className="page-header">
                      <h3 className="font-weight-normal mb-0 line-ht fs-24 color-33 text-nowrap">
                        Price Recommendation
                      </h3>
                      <div className="pr-page-actions">
                        <div className="mxw-90">
                          <FormControl
                            type="text"
                            placeholder="Search By Table Name"
                            className="searchTxt mb-3 mb-lg-0"
                            value={searchText}
                            onChange={(e) =>
                              this.setState({ searchText: e.target.value })
                            }
                            onKeyDown={this.handleSearchKeyDown}
                          />
                          <span
                            className="icon-search pointer"
                            onClick={() => this.fetchAllData()}
                          ></span>
                        </div>

                        <Form.Control
                          as="select"
                          className="login-input select-rounded pr-country-filter"
                          value={filterCountry}
                          onChange={(e) =>
                            this.setState(
                              {
                                filterCountry: e.target.value,
                                editingCell: null,
                              },
                              () => this.fetchAllData(),
                            )
                          }
                        >
                          <option value="">All Countries</option>
                          {countries.map((c) => (
                            <option key={c.code} value={c.code}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>

                        <button
                          className="button rounded-pill btnPrimary text-nowrap px-4 py-2"
                          onClick={() =>
                            this.setState({ showAddCountryModal: true })
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "46px",
                            minWidth: "160px",
                            fontSize: "15px",
                            fontWeight: "500",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontSize: "20px", lineHeight: "1" }}>
                            +
                          </span>{" "}
                          Add Country
                        </button>

                        <div className="pr-actions-group">
                          <button
                            className="button rounded-pill btnPrimary text-nowrap px-4 py-2"
                            onClick={this.handleUpdateConfirm}
                            disabled={!this.state.hasChanges}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "46px",
                              minWidth: "160px",
                              fontSize: "15px",
                              fontWeight: "500",
                            }}
                          >
                            Update
                          </button>

                          <button
                            className="button rounded-pill btnDefault btnOutline text-nowrap px-4 py-2"
                            onClick={() =>
                              window.open(recommendedPricingGuidePDF, "_blank")
                            }
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "46px",
                              minWidth: "160px",
                              fontSize: "15px",
                              fontWeight: "500",
                            }}
                          >
                            View Guideline
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Tables */}
                  <div className="row">
                    <div className="col-sm-12">
                      {(() => {
                        const query = (this.state.searchText || "")
                          .trim()
                          .toLowerCase();
                        const renderers = {
                          baseRates: () => this.renderBaseRatesTable(),
                          weightTiers: () => this.renderWeightTiersTable(),
                          itemClasses: () => this.renderItemClassesTable(),
                          urgency: () => this.renderUrgencyTable(),
                          vehicleTypes: () => this.renderVehicleTypesTable(),
                          timeOfDay: () => this.renderTimeOfDayTable(),
                        };
                        const sorted = [...TABLE_CONFIGS].sort((a, b) => {
                          if (!query) return 0;
                          const aMatch = a.heading.toLowerCase().includes(query)
                            ? 0
                            : 1;
                          const bMatch = b.heading.toLowerCase().includes(query)
                            ? 0
                            : 1;
                          return aMatch - bMatch;
                        });
                        return sorted.map((cfg) => (
                          <div key={cfg.key}>{renderers[cfg.key]()}</div>
                        ));
                      })()}
                    </div>
                  </div>
                </div>
              </div>
              <Footer {...this.props} />
            </Col>
          </Row>
        </div>

        <AddCountryModal
          show={showAddCountryModal}
          onHide={() => this.setState({ showAddCountryModal: false })}
          onAdd={this.handleAddCountry}
          existingCountryCodes={countries.map((c) => c.code)}
        />

        <Modal
          show={this.state.showUpdateConfirmModal}
          onHide={this.handleCloseUpdateConfirm}
          centered
          className="deliva-popup"
        >
          <Modal.Body>
            <div className="modal-content-wrap ">
              <div className="text-center">
                <Image
                  src={VerificationIcon}
                  className="img-fluid reject-img "
                />
                <h4 className=" mt-4 font-weight-normal mb-3 fs-24">
                  Update Confirmation
                </h4>
                <p className="color-grey">Are you sure you want to Update?</p>
              </div>

              <div className="text-center mt-5">
                <button
                  className="cancel-btn mr-4 min-w-80"
                  onClick={this.handleCloseUpdateConfirm}
                >
                  No
                </button>
                <button
                  className="b1-btn min-w-80"
                  onClick={this.handleConfirmUpdate}
                >
                  Yes
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesRedux: state.country.countries,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCountries: () => dispatch(actionFetchCountries()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PriceRecommendation);
